{
  "enum": {
    "IxcOrdersV1AllocationBasis": {
      "AMOUNT": "Amount",
      "PERCENTAGE": "Percentage",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1BatchAllocationStatus": {
      "CANCELED": "Canceled",
      "DISTRIBUTED": "Distributed",
      "DONE": "Done",
      "HELD": "Held",
      "HOLDING": "Holding",
      "INVALID": "Invalid",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "RELEASED": "Released",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1BatchOrderStatus": {
      "ACTIVE": "Active",
      "ASSEMBLING": "Assembling",
      "CANCELING": "Canceling",
      "DISTRIBUTING": "Distributing",
      "DONE": "Done",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1BatchOutcome": {
      "FULLY_FILLED": "Fully Filled",
      "NOT_FILLED": "Not Filled",
      "PARTIALLY_FILLED": "Partially Filled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1BooksOrderDoneOutcome": {
      "FULLY_FILLED": "Fully Filled",
      "PARTIALLY_FILLED": "Partially Filled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1Capacity": {
      "AGENT": "Agent",
      "CLEARING_PRINCIPAL": "Clearing Principal",
      "CORRESPONDENT_PRINCIPAL": "Correspondent Principal",
      "PRINCIPAL": "Principal",
      "RISKLESS_PRINCIPAL": "Riskless Principal",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1CommissionSimpleRateBasis": {
      "GROSS": "Gross",
      "NET": "Net",
      "QUANTITY": "Quantity",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1Counterparty": {
      "BOOKS": "Books",
      "MONEY_MARKET": "Money Market",
      "ROUTE": "Route",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1FirmOrderOutcome": {
      "FULLY_FILLED": "Fully Filled",
      "NOT_FILLED": "Not Filled",
      "PARTIALLY_FILLED": "Partially Filled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1Market": {
      "ARCX": "ARCX",
      "BATS": "BATS",
      "BATY": "BATY",
      "EDGA": "EDGA",
      "EDGX": "EDGX",
      "IEXG": "IEXG",
      "JNST": "JNST",
      "OTH": "OTH",
      "UNSPECIFIED": "Unspecified",
      "XASE": "XASE",
      "XBOS": "XBOS",
      "XCHI": "XCHI",
      "XCIS": "XCIS",
      "XNAS": "XNAS",
      "XNYS": "XNYS",
      "XPSX": "XPSX"
    },
    "IxcOrdersV1MiddleMoneyClass": {
      "CAT": "CAT",
      "COMMISSION": "Commission",
      "FFTT": "FFTT",
      "SEC": "SEC",
      "TAF": "TAF",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1OrderAmountConversionReason": {
      "FULL_POSITION_REDEMPTION": "Full Position Redemption",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1OrderEventTypeDoneOutcome": {
      "FULLY_FILLED": "Fully Filled",
      "NOT_FILLED": "Not Filled",
      "PARTIALLY_FILLED": "Partially Filled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1OrderEventTypeRejectedParty": {
      "ROUTE": "Route",
      "SYSTEM": "System",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1OrderInstructionTimeInForce": {
      "DAY": "Day",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1OrderRejectionCode": {
      "BALANCE_HOLD_REJECTED": "Balance Hold Rejected",
      "ESTIMATED_NOTIONAL_ZERO": "Estimated Notional Zero",
      "MARKET_CLOSED": "Market Closed",
      "QUANTITY_PRECISION_EXCEEDED": "Quantity Precision Exceeded",
      "ROUTE_REJECTED": "Route Rejected",
      "SYMBOL_BUY_NOT_ALLOWED": "Symbol Buy Not Allowed",
      "SYMBOL_FRACTIONS_NOT_ALLOWED": "Symbol Fractions Not Allowed",
      "SYMBOL_HALTED": "Symbol Halted",
      "SYMBOL_NOT_ACTIVE": "Symbol Not Active",
      "SYMBOL_NOT_FOUND": "Symbol Not Found",
      "SYMBOL_NOT_SUPPORTED": "Symbol Not Supported",
      "SYMBOL_SELL_NOT_ALLOWED": "Symbol Sell Not Allowed",
      "TAX_LOT_SELECTION_INVALID": "Tax Lot Selection Invalid",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1OrderStatus": {
      "ACTIVE": "Active",
      "APPROVAL": "Approval",
      "DONE": "Done",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1PriceSource": {
      "AVERAGE": "Average",
      "QUOTE": "Quote",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1Side": {
      "BUY": "Buy",
      "SELL": "Sell",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1TradingHours": {
      "EXTENDED": "Extended",
      "REGULAR": "Regular",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcOrdersV1TrfStatus": {
      "ACCEPTED": "Accepted",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListFilterableFields": {
      "accountId": "Account",
      "batchAllocationId": "Batch Allocation",
      "batchOrderId": "Batch Order",
      "status": "Status"
    },
    "IxcOrdersV1BatchOrderQueryServiceBatchOrderListFilterableFields": {
      "accountId": "Account",
      "batchOrderId": "Batch Order",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Asset Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity: Can Buy",
                  "canEnterFractions": "Equity: Can Enter Fractions",
                  "canSell": "Equity: Can Sell"
                },
                "cusip": "Equity: CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market: Classification",
                "controls": {
                  "canBuy": "Money Market: Can Buy",
                  "canEnterFractions": "Money Market: Can Enter Fractions",
                  "canSell": "Money Market: Can Sell"
                },
                "cusip": "Money Market: CUSIP",
                "navType": "Money Market: NAV Type"
              }
            }
          },
          "status": "Asset Status"
        },
        "instruction": {
          "side": "Side"
        }
      },
      "programId": "Program",
      "status": "Status"
    },
    "IxcOrdersV1OrderQueryServiceOrderListFilterableFields": {
      "accountId": "Account",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity: Can Buy",
                  "canEnterFractions": "Equity: Can Enter Fractions",
                  "canSell": "Equity: Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market: Classification",
                "controls": {
                  "canBuy": "Money Market: Can Buy",
                  "canEnterFractions": "Money Market: Can Enter Fractions",
                  "canSell": "Money Market: Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market: NAV Type"
              }
            }
          },
          "status": "Status"
        },
        "batchOrderId": "Batch Order",
        "holdId": "Hold",
        "instruction": {
          "side": "Side"
        }
      },
      "orderId": "Order",
      "programId": "Program",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcOrdersV1AllocationSource": {
      "csvFile": "CSV File",
      "fileReference": "File Reference",
      "inline": "Inline",
      "jsonFile": "JSON File"
    },
    "IxcOrdersV1BatchAllocationEventType": {
      "canceled": "Canceled",
      "created": "Created",
      "distributed": "Distributed",
      "done": "Done",
      "holdIssued": "Hold Issued",
      "holdPlaced": "Hold Placed",
      "holdRejected": "Hold Rejected",
      "holdReleased": "Hold Released",
      "validationFailed": "Validation Failed"
    },
    "IxcOrdersV1BatchOrderEventType": {
      "allocationCreated": "Allocation Created",
      "allocationDistributed": "Allocation Distributed",
      "allocationFailed": "Allocation Failed",
      "allocationReady": "Allocation Ready",
      "allocationSkipped": "Allocation Skipped",
      "cancelRequested": "Cancel Requested",
      "distributed": "Distributed",
      "done": "Done",
      "fillReceived": "Fill Received",
      "orderCompleted": "Order Completed",
      "orderCreated": "Order Created",
      "quoteReceived": "Quote Received",
      "rejected": "Rejected",
      "requested": "Requested"
    },
    "IxcOrdersV1Commission": {
      "fixed": "Fixed",
      "simpleRate": "Simple Rate"
    },
    "IxcOrdersV1OrderAmount": {
      "notional": "Notional",
      "quantity": "Quantity"
    },
    "IxcOrdersV1OrderEventType": {
      "accepted": "Accepted",
      "approvalReply": "Approval Reply",
      "booksOrderDone": "Books Order Done",
      "cancelRequested": "Cancel Requested",
      "done": "Done",
      "fill": "Fill",
      "firmOrderDone": "Firm Order Done",
      "rejected": "Rejected",
      "requested": "Requested",
      "routeBooks": "Route Books",
      "routeExternal": "Route External",
      "routeFirm": "Route Firm",
      "routeMoneyMarket": "Route Money Market",
      "trfReportUpdated": "TRF Report Updated"
    },
    "IxcOrdersV1OrderEventTypeApprovalReplyType": {
      "reservation": "Reservation",
      "symbol": "Symbol"
    },
    "IxcOrdersV1OrderInstructionTaxLotSelection": {
      "custom": "Custom",
      "wellKnown": "Well Known"
    }
  },
  "searchEnum": {
    "IxcOrdersV1BatchOrderQueryServiceBatchOrderListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity: Name",
                "symbol": {
                  "base": "Equity: Symbol"
                }
              },
              "moneyMarket": {
                "name": "Money Market: Name",
                "symbol": {
                  "base": "Money Market: Symbol"
                }
              }
            }
          }
        }
      }
    },
    "IxcOrdersV1OrderQueryServiceOrderListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity: Name",
                "symbol": {
                  "base": "Equity: Symbol"
                }
              },
              "moneyMarket": {
                "name": "Money Market: Name",
                "symbol": {
                  "base": "Money Market: Symbol"
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcOrdersV1BatchAllocationQueryServiceBatchAllocationListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcOrdersV1BatchOrderQueryServiceBatchOrderListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Asset Created At",
            "updatedAt": "Asset Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcOrdersV1OrderQueryServiceOrderListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Created At",
            "updatedAt": "Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}